


























































import { mapActions, mapState } from 'vuex';
import BackgroundCover from '@/components/BackgroundCover.vue';
import Logo from '@/components/Logo.vue';
import SearchBox from '@/components/search/SearchBox.vue';

export default {
  props: {
    enabled: {
      type: Boolean,
      default: false,
    },
  },
  created() {
    if (this.$store.state.chrome) {
      return;
    }

    // create module
    this.$store.registerModule('chrome', {
      namespaced: true,
      state: {
        activeElement: null,
        isMenuOpen: false,
        stackIndex: 0,
      },
      mutations: {
        SHOW_STACK: (state: any, stackIndex: number) => {
          state.stackIndex = stackIndex;
        },
        TOGGLE_MENU: (state: any, value: any) => {
          state.isMenuOpen = value === undefined
            ? !state.isMenuOpen
            : value;

          if (state.isMenuOpen) {
            // save currently focused element
            state.activeElement = document.activeElement;

            // select first nav item (not header)
            const menuSelector = '[class*=Wrapper_nav_] a';
            const [, menuElement]: NodeListOf<HTMLAnchorElement> = document.querySelectorAll(menuSelector);
            menuElement && menuElement.focus();
          } else {
            // focus on previously focused element
            // when closing menu
            state.activeElement && state.activeElement.focus();
          }
        },
      },
      actions: {
        showStack: ({ commit }: any, index: any) => commit('SHOW_STACK', index),
        toggleMenu: ({ commit }: any, value: any) => commit('TOGGLE_MENU', value),
      },
    });

    // focus on search field when the search window is focused on
    this.$store.subscribe((mutation: any) => {
      if (mutation.type === 'chrome/SHOW_STACK') {
        setTimeout(() => {
          if (mutation.payload === 1) {
            // save active element to refocus on once exited
            this.activeElement = document.activeElement;
            const searchField: HTMLElement|null = document.querySelector('#globalSearchField');
            searchField && searchField.focus();
          } else {
            this.activeElement && this.activeElement.focus();
          }
        }, 250);
      }
    });
  },
  beforeDestroy() {
    // ensure menu is hidden when going to a different page
    this.$store.dispatch('chrome/toggleMenu', false);
  },
  data: () => ({
    activeElement: null,
    estates: [
      'dashboard',
      'batches',
      'components',
      'linesheets',
      'materials',
      'products',
      'vendors',
    ],
  }),
  computed: {
    ...mapState('chrome', [
      'isMenuOpen',
      'stackIndex',
    ]),
    // don't allow any tabbing of menu items
    // when the menu is not open
    tabIndex() {
      return this.isMenuOpen ? 0 : -1;
    },
  },
  methods: {
    ...mapActions('chrome', [
      'showStack',
      'toggleMenu',
    ]),
    logout() {
      this.$store.dispatch('auth/logout');
    },
    switchStack(index: number) {
      if (this.isMenuOpen) {
        this.toggleMenu();
        this.showStack(index);
      }
    },
  },
  components: {
    BackgroundCover,
    Logo,
    SearchBox,
  },
} as IView;
